import { TypeIconName } from '@bitrise/bitkit';

export type ProjectType =
  | 'ios'
  | 'macos'
  | 'android'
  | 'cordova'
  | 'ionic'
  | 'react-native'
  | 'flutter'
  | 'kotlin-multiplatform'
  | 'fastlane'
  | 'node-js'
  | 'go'
  | 'other';

export const PROJECT_TYPE_OPTIONS: Array<{ value: ProjectType; text: string; icon: TypeIconName }> = [
  { value: 'ios', text: 'iOS', icon: 'Apple' },
  { value: 'macos', text: 'macOS', icon: 'Macos' },
  { value: 'android', text: 'Android', icon: 'Android' },
  { value: 'cordova', text: 'Cordova', icon: 'Cordova' },
  { value: 'ionic', text: 'Ionic', icon: 'Ionic' },
  { value: 'react-native', text: 'React Native', icon: 'ReactIcon' },
  { value: 'flutter', text: 'Flutter', icon: 'Flutter' },
  { value: 'kotlin-multiplatform', text: 'Kotlin Multiplatform', icon: 'Kotlin' },
  { value: 'fastlane', text: 'Fastlane', icon: 'Fastlane' },
  { value: 'node-js', text: 'Node.js', icon: 'Nodejs' },
  { value: 'go', text: 'Go', icon: 'Go' },
  { value: 'other', text: 'Other', icon: 'Other' },
];

export const PROJECT_TYPE_ICON_MAP: Record<ProjectType, TypeIconName> = PROJECT_TYPE_OPTIONS.reduce(
  (acc, { value, icon }) => {
    acc[value] = icon;
    return acc;
  },
  {} as Record<ProjectType, TypeIconName>,
);

export const PROJECT_TYPE_NAME_MAP: Record<ProjectType, string> = PROJECT_TYPE_OPTIONS.reduce(
  (acc, { value, text }) => {
    acc[value] = text;
    return acc;
  },
  {} as Record<ProjectType, string>,
);
